import * as z from 'zod';
import { ParticipantStatusSchema } from '../enums/ParticipantStatus.schema';

export const EventParticipantSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  eventPricePointId: z.string().nullish(),
  status: ParticipantStatusSchema.default("PENDING"),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  paymentAmountCents: z.number().int().nullish(),
  stripePaymentIntentId: z.string().nullish(),
  stripePaymentIntentStatus: z.string().nullish(),
  stripeRefundId: z.string().nullish(),
  depositAmountCents: z.number().int().int().min(0).nullish(),
  depositStripePaymentIntentId: z.string().nullish(),
  depositStripePaymentIntentStatus: z.string().nullish(),
  depositCapturedAt: z.coerce.date().nullish(),
  depositRefundId: z.string().nullish(),
  balanceDueAt: z.coerce.date().nullish(),
  consentFormParticipantDateOfBirth: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParticipantPronouns: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParticipantAddress: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerFirstName: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerSurname: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerAddress: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerRelationship: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormParentCarerContactNumber: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact1Name: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact1Relationship: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact1Phone: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact2Name: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact2Relationship: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormEmergencyContact2Phone: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormImportantMedicalInformation: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormMedicationDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormInjuriesDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormDietaryRequirementsDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormDisabilityDetails: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  consentFormCodeOfConductAccepted: z.boolean().nullish(),
  codeOfConductConsentedAt: z.coerce.date().nullish(),
  photoConsent: z.boolean().nullish(),
  photoConsentedAt: z.coerce.date().nullish(),
  marketingConsent: z.boolean(),
  marketingConsentedAt: z.coerce.date().nullish(),
  approvedAt: z.coerce.date().nullish(),
  approvedBy: z.string().nullish(),
  rejectedAt: z.coerce.date().nullish(),
  rejectedBy: z.string().nullish(),
  rejectionReason: z.string().nullish(),
  cancelledAt: z.coerce.date().nullish(),
  cancelledBy: z.string().nullish(),
  cancellationReason: z.string().nullish(),
  paymentCapturedAt: z.coerce.date().nullish(),
  paymentReleasedAt: z.coerce.date().nullish(),
  balanceTakenAt: z.coerce.date().nullish(),
  balanceTakenBy: z.string().nullish(),
  balanceCronExcluded: z.boolean(),
  sharedPaymentIntentId: z.string().nullish(),
  sharedPaymentIntentStatus: z.string().nullish(),
  sharedAllocatedAmountCents: z.number().int().nullish(),
  sharedAllocatedRefundId: z.string().nullish(),
  sharedDepositPaymentIntentId: z.string().nullish(),
  sharedDepositPaymentIntentStatus: z.string().nullish(),
  sharedDepositAllocatedAmountCents: z.number().int().nullish(),
  sharedDepositAllocatedRefundId: z.string().nullish(),
  submittedAt: z.coerce.date().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userId: z.string().nullish(),
  checkoutId: z.string().nullish(),
  boatId: z.string().nullish(),
  bookingEmailAddress: z.string().nullish(),
  group: z.string().max(200).transform(v => v?.trim() || null).nullable().nullish(),
  dataProcessingConsent: z.boolean().nullish(),
  dataProcessingConsentedAt: z.coerce.date().nullish(),
  emergencyTreatmentConsent: z.boolean().nullish(),
  emergencyTreatmentConsentedAt: z.coerce.date().nullish(),
});

export type EventParticipantType = z.infer<typeof EventParticipantSchema>;
